import React from 'react';
import { NotificationManager } from 'react-notifications';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-notifications/lib/notifications.css';
import * as absencesActions from '../../../store/portal';
import * as lvgActions from '../../../store/admin';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { config } from '../../../config/config';
import { GridLoader } from 'react-spinners';
import { css } from '@emotion/core';

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
class LVGoalsUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_saving: false,
      fileSelected: false,
      selectedFile: null,
      selectedFileName: '',
      isLoading: false,
    };
    this.fileInput = React.createRef();
  }
  handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    this.setState(
      {
        ...this.state,
        selectedFileName: selectedFile.name,
        selectedFile: selectedFile,
      },
      () => {
        console.log('Updated state:', this.state);
      }
    );
  };

  handleUpload = async () => {
    this.setState({ isLoading: true });
    if (this.state.selectedFile) {
      try {
        const formData = new FormData();
        formData.append(
          'file',
          this.state.selectedFile,
          this.state.selectedFileName
        );

        this.setState({ is_saving: true });
        const response = await fetch(
          config.api_url + 'import-student-lv-goals-csv',
          {
            method: 'POST',
            headers: {
              Authorization: this.props.token,
            },
            body: formData,
          }
        );
        console.log('API response:', response);
        NotificationManager.success(
          'Success message',
          'Processing file...'
        );
      } catch (error) {
        console.error('Error uploading file:', error);

        NotificationManager.error('Something Went Wrong' + error);
      } finally {
        this.setState({
          is_saving: false,
          selectedFile: null,
          selectedFileName: '',
        });
      }
    } else {
      NotificationManager.error('No file selected.');
    }

    this.setState({ ...this.state, isLoading: false, is_saving: false,
          selectedFile: null,
          selectedFileName: '', });
  };

  handleFileButtonClick = () => {
    this.fileInput.current.click();
  };

  render() {
    return (
      <div>
        <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
          <h1>UPLOAD LEARNING VIRTUES GOALS</h1>
        </div>
        <div id="accordion" className="pt-3">
          <div className="card">
            <div className="card-body">
              <div
                className="filters"
                style={{ padding: '2rem 2rem 2rem 2rem' }}
              >
                <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                  <div className="d-flex w-100">
                    <form
                      ref={this.fileInput}
                      className="d-flex align-items-center"
                    >
                      <label
                        htmlFor="fileInput"
                        className="file-input-label mr-1"                        
                      >
                        <input
                          type="file"
                          id="fileInput"
                          className="fileInput"
                          accept=".csv"
                          disabled={this.state.is_saving}
                          onChange={this.handleFileSelect}
                          style={{ display: 'none', 
                          padding: "0 3rem",
                          height: "40px",
                          borderRadius: "6px",
                          backgroundColor: "#3276bc",
                          border: 0,
                          fontSize: "15px",
                          fontWeight: 600,
                          fontStretch: "normal",
                          fontStyle: "normal",
                          letterSpacing: "normal",
                          color: "#ffffff",
                          cursor: "pointer",
                          textTransform: "uppercase", 
                        }} // Hide the file input
                        />
                        <span
                          className="button-style"
                          style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                          }}
                        >
                          Select CSV File
                        </span>
                      </label>
                      <button
                        type="button"
                        onClick={this.handleUpload}
                        disabled={!this.state.selectedFile}
                        style={{
                          backgroundColor: this.state.selectedFile
                            ? ''
                            : '#6f7881ba',
                        }}
                      >
                        Import to DynamoDB
                      </button>
                    </form>
                  </div>
                </div>
                {this.state.selectedFileName && (
                  <div>
                    Selected File: {this.state.selectedFileName}
                  </div>
                )}
                      </div>
            </div>
          </div>
        </div>
        {this.state.isLoading === true && (
          <div className="sweet-loading">
            <GridLoader
              css={override}
              sizeUnit={'px'}
              size={40}
              color={'#cadb2a'}
              loading={this.state.isLoading}
            />
          </div>
        )}
        <div className="overlay"></div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    parentDashboardActionLoading: state.parentDashboard.actionsloading,
    larningGoalsPDFActionLoading: state.larningGoalsPDF.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    parentDashboard: state.parentDashboard,
    larningGoalsPDF: state.larningGoalsPDF,
    pre_signed_URL: state.studentGoals.pre_signed_URL || '',
    studentGoalLoading: state.studentGoals
      ? state.studentGoals.actionsloading
      : false,
    queuePDF: Object.values(state.queuePDF.byId),
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, absencesActions, lvgActions), dispatch)
)(LVGoalsUpload);
